"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var GetHeaderIcon_1 = __importDefault(require("./GetHeaderIcon"));
var InputModal_1 = __importDefault(require("./InputModal"));
exports.default = (function (createUi, invoke, $log, environment, savedStyleService) {
    return function (style) {
        if (environment !== "production") {
            $log.log("Renaming Style:", style);
        }
        var customHeader = createUi(require("./RenameStyleModalHeader.html"), {
            icon: invoke(GetHeaderIcon_1.default)(style),
        });
        return invoke(InputModal_1.default)({
            customHeader: customHeader,
            yesButton: "Rename style",
            style: style,
            confirming: savedStyleService.renameStyle,
        });
    };
});
